import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    getCoursesInCart,
    addToCart,
    removeFromCart,
    addToCartFromWishlist
} from '../../../../API/Course';

const initialState = {
    cartItems: [],
    loading: false,
    error: null
};

export const fetchCart = createAsyncThunk(
    'cart/fetchCart',
    async (token, { rejectWithValue }) => {
        try {
            const data = await getCoursesInCart(token);
            return data || [];
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const addCartItem = createAsyncThunk(
    'cart/addCartItem',
    async ({ courseId, token, toast }, { dispatch, rejectWithValue }) => {
        try {
            const response = await addToCart(courseId, token, toast);
            dispatch(fetchCart(token));
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const removeCartItem = createAsyncThunk(
    'cart/removeCartItem',
    async ({ courseId, token }, { dispatch, rejectWithValue }) => {
        try {
            const response = await removeFromCart(courseId, token);
            dispatch(fetchCart(token));
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

export const addCartItemFromWishlist = createAsyncThunk(
    'cart/addCartItemFromWishlist',
    async ({ courseId, token, toast }, { dispatch, rejectWithValue }) => {
        try {
            const response = await addToCartFromWishlist(
                courseId,
                token,
                toast
            );
            dispatch(fetchCart(token));
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        clearCart: (state) => {
            state.cartItems = [];
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCart.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCart.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.cartItems = payload;
            })
            .addCase(fetchCart.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            });
    }
});

export const { clearCart } = cartSlice.actions;
export default cartSlice.reducer;
